import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { CircularProgress } from '@mui/material';
import Alert, { useAlert } from 'components/snacks/Alert';
import Box from '@mui/material/Box';

import { axiosInstance } from 'api/Api';
import Sidebar from './Sidebar';

const Login = () => {
  // DATA
  const history = useHistory();
  const autoHideAlert = 3000;
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [product, setProduct] = useState('');
  const [locale, setLocale] = useState('');

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);

  // LOAD
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const product = urlParams.get('product');
    const locale = urlParams.get('locale');
    setProduct(product);
    setLocale(locale)
    // ///////////////
    if (!localStorage.getItem('login_phone_number')) {
      history.push('/login');
    }
  }, []);

  const submitForm = (e) => {
    e.preventDefault();
    if ( password === '' )
    {
      alertStore.AddAlert({
        key: 'empty-password',
        message: 'لطفا کلمه عبور را وارد کنید',
        severity: 'error',
        auto_hide: true
      });
    } else {
      setLoading(true);
      const formData = new FormData();
      formData.append('username', localStorage.getItem('login_phone_number'));
      formData.append('password', password);
      axiosInstance()
        .post(`/login`, formData)
        .then((res) => {
          const result = res.data;
          if (result.status === 200) {
            localStorage.removeItem('login_phone_number');
            localStorage.setItem('token', result.token);
            localStorage.setItem(
                'user_info',
                JSON.stringify(result.user_info)
            );
            if (product) {
              return history.push(`/services/server-iran/server-order?id=${product}`,  {
                id: product
              });
            } else {
              window.location.pathname = '/';
            }

          } else {
            alertStore.AddAlert({
              key: '400',
              message: result.msg,
              severity: 'error',
              auto_hide: true
            });
          }
        })
        .catch((err) => {
          if (err?.response?.data?.message)
            alertStore.AddAlert({
              key: '500',
              message: err?.response?.data?.message,
              severity: 'error',
              auto_hide: true
            });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // JSX
  return (
    <div className="row mx-0 px-0 ">
      {/* **************** TITLE **************** */}
      <div className="col-12 col-md-6 px-0">
        <Sidebar />
      </div>
      {/* **************** FORM **************** */}
      <div className="col-12 col-md-6 px-0">
        {loading ? (
          <div className="h-full h-md-fit d-flex justify-content-center align-items-center mt-5 my-md-0">
            <Box sx={{ display: 'flex', marginRight: '20px' }}>
              <CircularProgress />
            </Box>
          </div>
        ) : (
          <form
            method="post"
            onSubmit={submitForm}
            className="h-full h-md-fit d-flex justify-content-center align-items-center mt-5 my-md-0"
          >
            <div style={{ width: '65%' }}>
              <h1 className="mb-10 mt-10 mt-md-0 text-center">ورود به حساب</h1>
              <hr />
              <label htmlFor="login_password" className="form-label fs-2 mt-10">
                کلمه عبور خود را وارد کنید:
              </label>
              <div className="position-relative">
                <input
                  type={showPass ? 'text' : 'password'}
                  id="login_password"
                  className="form-control login-input direction-ltr"
                  placeholder="*********"
                  autoFocus={true}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  value={password}
                />
                <button
                  type={'button'}
                  style={{ top: 0 }}
                  className="btn position-absolute"
                  onClick={() => setShowPass(!showPass)}
                >
                  {!showPass ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-eye"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-eye-slash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                    </svg>
                  )}
                </button>
              </div>
              <p className="m-0 mt-5">
                <Link to="/forgot-pass" className={'text-muted'}>
                  رمز عبور خود را فراموش کردید؟
                </Link>
              </p>
              <button className="btn btn-primary mt-3">تایید</button>
              <Link
                to={product && locale ? `/login?product=${product}&locale=${locale}` :"/login"}
                className="btn btn-light-primary fw-bolder mt-3 ms-3"
              >
                بازگشت
              </Link>
            </div>
          </form>
        )}
      </div>
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </div>
  );
};

export default Login;
